if (!customElements.get("ootd-item")) {
  customElements.define(
    "ootd-item",
    class OotdItem extends HTMLElement {
      constructor() {
        super();
        this.defaultSize = ['M', '34', 'C'];
      }

      init() {
        // 产品 json 数据
        const scriptEl = this.querySelector('#_ql_product');
        if (!scriptEl) return;
        const jsonStr = scriptEl.textContent.trim();
        if (!jsonStr) return;
        try {
          this.productData = JSON.parse(jsonStr);
        } catch (error) {
          return;
        }

        this.variants = this.productData.variants;

        this.form = this.querySelector('form.product-card-form');
        if (!this.form) return;
        this.selectVariant = this.form.querySelector('input[name="id"]');
        if (!this.selectVariant) return;

        this.optionsContainers = this.querySelectorAll('.product-card__options .variant-picker__field');
        if (!this.optionsContainers.length) return;

        // 默认选中 OOTD 指定的颜色
        const ootdColor = this.getAttribute('data-ootd-color');
        if (ootdColor) {
          const colorInput = this.querySelector(`.product-card__options .variant-picker__field[data-is-color="true"] input[value="${ootdColor}"]`);
          if (colorInput) colorInput.checked = true;
        }

        // 默认选中常见尺码
        this.optionsContainers.forEach((container) => {
          if (container.getAttribute('data-is-color') === 'true') return;
          const select = container.querySelector('select');
          if (!select) return;
          for (const size of this.defaultSize) {
            const option = select.querySelector(`option[value="${size}"]`);
            if (option) {
              select.value = size;
              break;
            }
          }
        });

        this.updateVariant();
        this.updateImage();

        // 监听选项变化
        this.optionsContainers.forEach((el) => {
          const isColor = el.getAttribute('data-is-color') === 'true';
          if (isColor) {
            el.addEventListener('change', (e) => {
              if (e.target.tagName === 'INPUT') {
                this.updateImage();
                this.updateVariant();
              }
            });
          } else {
            el.addEventListener('change', (e) => {
              if (e.target.tagName === 'SELECT') {
                this.updateVariant();
              }
            });
          }
        });

        // 让加购按钮走主题的 AJAX 购物车
        const atcButton = this.form.querySelector('[data-add-to-cart]');
        if (atcButton) {
          atcButton.addEventListener('click', (e) => {
            e.preventDefault();
            if (atcButton.hasAttribute('disabled')) return;
            document.dispatchEvent(
              new CustomEvent('theme:cart:add', {
                detail: { button: atcButton },
                bubbles: false,
              })
            );
          });
        }
      }

      // 获取当前选中的选项值（以 option position 为 key 的 map）
      getSelectedOptions() {
        const selectedMap = {};
        this.optionsContainers.forEach((el) => {
          const optionPosition = el.getAttribute('data-option-position');
          const labelEl = el.querySelector('.selected-value');
          const isColor = el.getAttribute('data-is-color') === 'true';

          if (isColor) {
            const selected = el.querySelector('input:checked');
            if (selected) {
              selectedMap[optionPosition] = selected.value;
              if (labelEl) labelEl.textContent = selected.value;
            }
          } else {
            const select = el.querySelector('select');
            if (select) {
              selectedMap[optionPosition] = select.value;
              if (labelEl) labelEl.textContent = select.value;
            }
          }
        });
        return selectedMap;
      }

      // 更新隐藏字段 input[name="id"] 为匹配变体
      updateVariant() {
        const selectedMap = this.getSelectedOptions();
        const foundVariant = this.variants.find((variant) => {
          return this.productData.options.every((option, index) => {
            const position = index + 1;
            const optionKey = 'option' + position;
            const value = selectedMap[String(position)];
            return value !== undefined && variant[optionKey] === value;
          });
        });

        if (foundVariant && this.selectVariant) {
          this.selectVariant.value = foundVariant.id;
          const atcButton = this.form.querySelector('[data-add-to-cart]');
          if (atcButton) {
            atcButton.toggleAttribute('disabled', !foundVariant.available);
          }
        } else {
          console.warn('[OOTD] variant not found for', selectedMap, 'product options:', this.productData.options);
        }
      }

      // 根据选中的颜色切换产品图片
      updateImage() {
        const selected = this.querySelector('.product-card__options .variant-picker__field[data-is-color="true"] input:checked');
        if (!selected) return;
        const imgEl = this.querySelector('.product-card__image--main img');
        if (!imgEl) return;
        const imgSrc = selected.getAttribute('data-variant-image');
        const imgSrcset = selected.getAttribute('data-image-srcset');
        if (imgSrc) {
          imgEl.src = imgSrc;
          if (imgSrcset) imgEl.srcset = imgSrcset;
        }
      }

      // 兼容 theme.dev.js 中 setOotd 的调用
      getSelectOptions() {
        const selectedMap = this.getSelectedOptions();
        return this.productData.options.map((option) => selectedMap[String(option.position)]);
      }

      changeVariantId(selectOptions) {
        this.productData.options.forEach((option, index) => {
          const value = selectOptions[index];
          if (value === undefined) return;
          const optionPosition = String(option.position);
          const container = Array.from(this.optionsContainers).find((el) => el.getAttribute('data-option-position') === optionPosition);
          if (!container) return;
          const isColor = container.getAttribute('data-is-color') === 'true';
          if (isColor) {
            const input = container.querySelector(`input[value="${value}"]`);
            if (input) input.checked = true;
          } else {
            const select = container.querySelector('select');
            if (select) select.value = value;
          }
        });
        this.updateVariant();
        this.updateImage();
      }
    }
  );
}
